/**
 * MaioS 브랜드 워드마크 (admin) — 클라이언트 Brand.tsx와 동일 스타일.
 * M·S = 다크그린(#3f7d39), aio = 강조 그린(#82bd3e).
 * variant="light"는 어두운 배경용(M·S 흰색).
 */
export const BRAND_DARK = '#3f7d39';
export const BRAND_ACCENT = '#82bd3e';

interface WordmarkProps {
  className?: string;
  variant?: 'default' | 'light';
}

export default function Wordmark({ className = '', variant = 'default' }: WordmarkProps) {
  const primary = variant === 'light' ? '#ffffff' : BRAND_DARK;
  return (
    <span className={`inline-block font-bold select-none tracking-tight ${className}`}>
      <span style={{ color: primary }}>M</span>
      <span style={{ color: BRAND_ACCENT }}>aio</span>
      <span style={{ color: primary }}>S</span>
    </span>
  );
}
